export const dashboardPagesMenu = {
	wizard: {
		id: 'wizard',
		text: 'BO',
		path: '/',
		icon: 'Local Offer',
		subMenu: null,
	},
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/dashboard',
		icon: 'Dashboard',
		subMenu: null,
	},
	boApproval: {
		id: 'boApproval',
		text: 'BO Approval',
		path: '/bo-approval',
		icon: 'Approval',
		subMenu: null,
	},
	boplan: {
		id: 'boplan',
		text: 'BO Plan',
		path: '/bo-plan',
		icon: 'Local Offer',
		subMenu: null,
	},
	bogreetings: {
		id: 'bogreetings',
		text: 'BO Greetings',
		path: '/bo-greetings',
		icon: 'Dashboard',
		subMenu: null,
	},
	individualNote: {
		id: 'individualNote',
		text: 'How to Open Individual BO Account',
		path: '/individual-bo-account-guide',
		icon: 'Person',
		subMenu: null,
	},
	jointNote: {
		id: 'jointNote',
		text: 'How to Open Joint BO Account',
		path: '/joint-bo-account-guide',
		icon: 'People',
		subMenu: null,
	},
	// wizard: {
	// 	id: 'wizard',
	// 	text: 'BO Wizard',
	// 	path: '/bo-wizard',
	// 	icon: 'Local Offer',
	// 	subMenu: null,
	// },
};

export const demoPagesMenu = {
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
	login: {
		id: 'Login',
		text: 'Login',
		path: '/auth-pages/login',
		icon: 'Login',
	},
};
